// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"fadb1ba7","547":"da1c04bd","777":"328c793d","845":"31aa32c2"}[chunkId] + ".chunk.css";
};